import { render } from "./InfoButton.vue?vue&type=template&id=fea945ce&scoped=true"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"

import "./InfoButton.vue?vue&type=style&index=0&id=fea945ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea945ce"]])

export default __exports__